import { useMemo } from 'react'
import groupBy from 'lodash/groupBy.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data) return data

    let { last_questions, last_answers } = data

    let questions = last_questions.filter(item => item.answers.length === 0)

    if (questions.length === 0) {
      return null
    }

    let filteredQuestions = groupBy(
      questions,
      question =>
        `${question.organization_id}|${question.name.toLowerCase()}|${
          question.type
        }`
    )

    let answersByQuestion = groupBy(
      last_answers,
      answer =>
        `${
          answer.question.organization_id
        }|${answer.question.name.toLowerCase()}|${answer.question.type}`
    )

    return Object.keys(filteredQuestions).find(
      questionKey => answersByQuestion[questionKey]
    )
  }, [data])
}
